import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Head from './Head';
import Body from './Body';

const ChildPanelsTable = ({ isLoading, items, config, setOpenModal, setModalData }) => {
  const handleSelect = (args) => {
    const { key } = args;
    setModalData({
      actionKey: key,
      ...args,
    });

    switch (key) {
    case 1:
      setOpenModal('confirm');
      break;

    default:
      break;
    }
  };

  return (
    <Table>
      <Head />
      <Body isLoading={isLoading} items={items} config={config} handleSelect={handleSelect} />
    </Table>
  );
};

ChildPanelsTable.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  config: PropTypes.object,
  setOpenModal: PropTypes.func,
  setModalData: PropTypes.func,
};

export default ChildPanelsTable;
